
import { Button } from "@/components/ui/button";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { useTranslation } from "react-i18next";

interface ActivityFiltersProps {
  categories: string[];
  selectedCategory?: string;
  onSelectCategory: (category: string | undefined) => void;
}

export const ActivityFilters = ({
  categories,
  selectedCategory,
  onSelectCategory
}: ActivityFiltersProps) => {
  const { t } = useTranslation();
  return <ScrollArea className="w-full whitespace-nowrap rounded-md border">
      <div className="flex w-max space-x-4 p-4">
        <Button 
          variant={selectedCategory === undefined ? "default" : "outline"} 
          onClick={() => onSelectCategory(undefined)} 
          className={`rounded-full ${
            selectedCategory === undefined 
              ? "bg-[#000835]" 
              : "bg-white text-black border border-gray-300 hover:bg-gray-100"
          }`}
        >
          {t("discover.allActivities", "All")}
        </Button>
        {categories.map(category => (
          <Button 
            key={category} 
            variant={selectedCategory === category ? "default" : "outline"} 
            onClick={() => onSelectCategory(category)} 
            className={`rounded-full ${
              selectedCategory === category 
                ? "bg-[#000835]" 
                : "bg-white text-black border border-gray-300 hover:bg-gray-100"
            }`}
          >
            {t(`discover.categories.${category.toLowerCase().replace(/[& ]/g, "")}`, category)}
          </Button>
        ))}
      </div>
      <ScrollBar orientation="horizontal" />
    </ScrollArea>;
};

export default ActivityFilters;
